<template>
    <div class="showFraction">
        <content-header>
            <div class="header-left-box" slot="header-left">
                <!-- <retuen-prev></retuen-prev> -->
                <div class="return-prev" @click="retuenPrev">
                    <span class="icon-box">
                        <span class="el-icon-arrow-left"></span>
                    </span>
                    <span class="return-text">{{$t('showFraction.FH')}}</span>
                </div>
                <content-header-title >
                    <span>{{$t('showFraction.CKCJ')}}</span>
                </content-header-title>
            </div>
        </content-header>
        <div class="main">
            <team-statistics :stData="stData"></team-statistics>
            <div class="table-box">
                <c-table
                    @operation="operation" 
                    :tableData="stData.itemList" 
                    :ISChangeCheckout="false" 
                    :tableHeader="teamTableHeader" 
                    :TableHeight="`calc( 100vh - ${324}px )`">
                </c-table>
            </div>
        </div>
    </div>
</template>
<script>
import main from '@/mins/main'
import CTable from '@/components/table'
import mins from './mins'
import teamStatistics from '@/views/showFraction/team-statistics'
import fetch from '@/api/fetch'
export default {
    name: 'showFraction',
    mixins: [mins,main],
    components:{
        teamStatistics,
        CTable
    },
    created(){
        this.getData()
    },
    methods:{
        retuenPrev(){
            let showFractionUrl = JSON.parse(sessionStorage.getItem('showFractionUrl'))
            console.log(showFractionUrl, 'showFractionUrl')
            this.$router.push(showFractionUrl)
        },
        getData(){
            let { planId } = JSON.parse(this.__Base64.decode(this.$route.query.q))
            fetch.statisIndex({
                planId
            }).then(res=>{
                if(res.code == 0){
                    this.stData = res.data
                    this.stData.itemList = this.stData.itemList.map((item,index)=>({...item,sortNo: ++index, maxScore: item.isAbsent == 1 ? this.$t('showFraction.QS') : Number(item.maxScore).toFixed(2), minScore: item.isAbsent == 1 ? this.$t('showFraction.QS') : Number(item.minScore).toFixed(2) }))
                }else{
                    this.$notify({ title: this.$t('showFraction.CZ'), message: res.msg || this.$t('showFraction.CZSB'), type: 'error' });
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.header-left-box{
    display: flex;
    .return-prev{
        cursor: pointer;
        color: #858C96;
        .icon-box{
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #B4BBCD;
            opacity: 0.2;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            color: #000;
            display: inline-block;
            vertical-align: 1px;
        }
        .return-text{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            letter-spacing: 1px;
            margin: 0 14px 0 6px;
            vertical-align: 1px;
        }
    }
    .return-prev:hover{
        color: #5397F7;
        .icon-box{
            color: #5397F7;
            opacity: .5;
        }
    }
}
.main{
    padding: 0 24px;
    box-sizing: border-box;
    width: calc(100vw - 208px);
    min-width: 1200px;
}
</style>